"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var ImageContext = /*#__PURE__*/_react["default"].createContext({
  getSrc: function getSrc(_ref) {
    var src = _ref.src;
    return src;
  },
  getSrcSet: function getSrcSet(_ref2) {
    var srcSet = _ref2.srcSet;
    return srcSet;
  }
});
var _default = exports["default"] = ImageContext;